import script from "./AdminLayoutNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminLayoutNav.vue?vue&type=script&setup=true&lang=ts"

import "./AdminLayoutNav.vue?vue&type=style&index=0&id=53a14f9d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53a14f9d"]])

export default __exports__